<template src="./index.html">
</template>
<script>
	//资产负债表
	import minhead from '../../../../common/minHead/index.vue'
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue'
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue'
	import {
		getdata
	} from './data.js'
	import config from '../../../../../../configHttp.js'
	import uploadFile from '../../../../common/uploadFile/index.vue'
	import uploadFileplus from '../../../../common/uploadFileplus/index.vue'
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd
	} from "../../../../../api/Draftgeneration.js"
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from "../../../../../api/bbmb.js"
	import {
		reportquerytrack
	} from "../../../../../api/xggj.js"
	import {
		zcfg_fycx,
		zcfg_fetch
	} from "../../../../../api/zcfg.js";
	import addzc from "../../../../common/addzc/index.vue";
	import seezc from "../../../../common/seezc/index.vue"
	import BalanceSheet_I from "./BalanceSheet_I/index.vue"
	import {
		getdata as getdataI
	} from './BalanceSheet_I/data.js'
	import BalanceSheet_II from "./BalanceSheet_II/index.vue"
	import {
		getdata as getdataII
	} from './BalanceSheet_II/data.js'
	import BalanceSheet_III from "./BalanceSheet_III/index.vue"
	import {
		getdata as getdataIII
	} from './BalanceSheet_III/data.js'
	import BalanceSheet_VI from "./BalanceSheet_VI/index.vue"
	import {
		getdata as getdataVI
	} from './BalanceSheet_VI/data.js'
	export default {
		name: '',
		components: {
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			uploadFile,
			uploadFileplus,
			addzc,
			seezc,
			BalanceSheet_I,
			BalanceSheet_II,
			BalanceSheet_III,
			BalanceSheet_VI,
		},
		props: {
			seeNow: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				default: ""
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ""
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: "填写"
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},

		mounted() {
			// this.gettable()
			if (this.toseeUpdate) {
				this.getShuibDetailList()
			} else {
				this.manuscriptqueryReportStep()
			}
		},
		data: function() {
			return {
				Changed:0,
				treestate: "",
				statedata: [],
				treedata: getdata().treedata,
				choosetitleindex: "",
				formlist: getdata().formlist,
				headobj: {},
				choosecellCode: "",
				smtext: "",
				zcdata: [],
				searchlistzc: getdata().searchlistzc,
				headDatazc: getdata().headDatazc,
				pagination: getdata().pagination,
				seezcformlist: getdata().seezcformlist,
				formdatazc: getdata().formdatazc, //form表单数据
				tableDataI_I: [],
				tableDataI_II: [],
				tableDataII_I: [],
				tableDataII_II: [],
				tableDataIII_I: [],
				tableDataIII_II: [],
				tableDataVI_I: [],
				ZeroHead: ['cwbbqykjzd_0_x_1', 'cwbbqykjzd_0_x_2'],
				IHead: ['cwbbqykjzd_1_x_1', 'cwbbqykjzd_1_x_2'],
				IIHead: ['cwbbqykjzd_2_x_1', 'cwbbqykjzd_2_x_2'],
				IIIHead: ['cwbbqykjzd_3_x_1', 'cwbbqykjzd_3_x_2', ],
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
			};
		},

		methods: {
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id)
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index)
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {

				if (this.$emptyandnull(table)) {
					this.choosecellCode = ""
					return false
				}
				this.choosetable = table
				this.chooseindex = index
				this.choosecolum = colum
				this.choosecellCode = this[table][index][colum].cellCode
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : ''
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : []
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || ''
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: "",
					zcs: []
				}
				this[table][index][colum]['map']['desc'] = smtext
				this[table][index][colum]['map']['zcs'] = zcdata
			},
			//点击全部范围
			refreshhover() {
				this.$nextTick(() => {
					this.$refs.boxref.refreshhover()
				})
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then(res => {
					if (res.data.code == 1) {
						this.treedata = res.data.data.detail
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0])
						}
						this.querycell()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then(res => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory
						this.treedata = res.data.data.detail
						// this.treedata[0].unshift()
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0])
						}
						this.querycell()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode
			},
			//表格隐藏显示和返回
			forback() {
				if(this.Changed>0){
						this.$showConfirm({
								message: "是否不保存当前修改?",
								title:"您还未保存",
						}).then((res) => {
								if (res == "confirm") {
										this.$emit('forback', true);
								}else{
										//取消
								}
						});
				}else{
					this.$emit('forback', true);
				}
			},
			changestate(e) {
				this.treestate = e
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = []
				filterlist.forEach(ytem => {
					let newval = data.map(item => {
						if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(
								item[ytem]) && item[ytem].cellVal != null) {
							return item[ytem]
						} else {
							return "x"
						}
					})
					newlist = [...newlist, ...newval].filter(gtem => gtem != 'x')
				})
				return newlist
			},
			refreshtableDataZero() {
				this.tableDataI_I.forEach((item, index) => {
					if (index != 0) {
						this.ZeroHead.forEach(gtem => {
							if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
								.cellVal != '- -') {
								item[gtem].cellVal = ""
								item[gtem].cellType = "0"
							}
						})
					}

				})
				this.tableDataI_II.forEach((item, index) => {
					this.ZeroHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			refreshtableDataI() {
				this.tableDataII_I.forEach((item, index) => {
					this.IHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
				this.tableDataII_II.forEach((item, index) => {
					this.IHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},

			//重置附表二
			refreshtableDataII() {
				this.tableDataIII_I.forEach((item, index) => {
					this.IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
				this.tableDataIII_II.forEach((item, index) => {
					this.IIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			//重置附表三
			refreshtableDataIII() {
				this.tableDataVI_I.forEach((item, index) => {
					this.IIIHead.forEach(gtem => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != "" && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = ""
							item[gtem].cellType = "0"
						}
					})
				})
			},
			//清空相关
			commanddcrefresh(e) {
				this.Changed++
				if (e == "now") {
					if (this.choosetitleindex == 'cwbbqykjzd_0') {
						this.refreshtableDataZero()
					}
					if (this.choosetitleindex == 'cwbbqykjzd_1') {
						this.refreshtableDataI()
					}
					if (this.choosetitleindex == 'cwbbqykjzd_2') {
						this.refreshtableDataII()
					}
					if (this.choosetitleindex == 'cwbbqykjzd_3') {
						this.refreshtableDataIII()
					}
				}
				if (e == "all") { Object.keys(this.headobj).map(key => (this.headobj[key] = ""));
					this.refreshtableDataZero()
					this.refreshtableDataI()
					this.refreshtableDataII()
					this.refreshtableDataIII()
					this.refreshtableDataVI()
				}
			},
			checkerror(){
				let arr = []
			},
			//所有表格渲染
			querycell(index) {

				if (this.type == "update") {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm,
					}).then(res => {
						let dataarr = res.data.data
						this.gettable(dataarr)
					})
				}
				if (this.type == "tosee") {
					if (this.seeNow) {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
						return false
					}
					if (this.toseeUpdate) {
						querytemplatecell({
							"shuibId": this.params.shuibId,
							"id": this.params.id
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
					} else {
						reportquerytrack({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
							trackId: this.params.trackId,
						}).then(res => {
							let dataarr = res.data.data
							this.gettable(dataarr)
						})
					}
				}
			},
			gettable(dataarr) {
				this.headobj = dataarr.head
				// this.treedata = getdata().treedata
				//主表
				dataarr.cwbbqykjzd_0.unshift({cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(15, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(19, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(29, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(34, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(35, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(38, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(53, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(55, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(62, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(65, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_0.splice(66, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.unshift({cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.splice(11, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.splice(22, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.splice(34, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.splice(52, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_2.splice(56, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_3.unshift({cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_3.splice(9, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_3.splice(22, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_3.splice(40, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				dataarr.cwbbqykjzd_3.splice(47, 0, {cwbbqykjzd_0_x_1: {cellType: "0",},cwbbqykjzd_0_x_2: {cellType: "0",}})
				// this.tableDataI_I = getdataI().tableDataI
				// this.tableDataI_II = getdataI().tableDataII
				// this.tableDataII_I = getdataII().tableDataI
				// this.tableDataII_II = getdataII().tableDataII
				// this.tableDataIII_I = getdataIII().tableDataI
				// this.tableDataIII_II = getdataIII().tableDataII
				// this.tableDataVI_I = getdataVI().tableDataI
				var newtabledataZero = dataarr.cwbbqykjzd_0
				var realtableDataout = newtabledataZero.filter((item, index) => index < 38)
				var realtableDataZero = getdataI().tableDataI
				realtableDataZero.forEach((item, index) => {
					if (newtabledataZero&&realtableDataout[index]) {
						this.ZeroHead.forEach(gtem => {
							item[gtem] = realtableDataout[index][gtem]
						})
					}
				})
				this.tableDataI_I = realtableDataZero
				var newtabledataV = newtabledataZero.filter((item, index) => index > 37)
				var realtableDataV = getdataI().tableDataII
				realtableDataV.forEach((item, index) => {
					if (newtabledataV&&newtabledataV[index]) {
						this.ZeroHead.forEach(gtem => {
							item[gtem] = newtabledataV[index][gtem]
						})
					}
				})
				this.tableDataI_II = realtableDataV
				// //附表一
				var newtabledataI = dataarr.cwbbqykjzd_1
				var realtableDatamax = newtabledataI.filter((item, index) => index < 16)
				var realtableDataI =getdataII().tableDataI
				realtableDataI.forEach((item, index) => {
					if (newtabledataI&&newtabledataI[index]) {
						this.IHead.forEach(gtem => {
							item[gtem] = newtabledataI[index][gtem]
						})
					}
				})
				this.tableDataII_I = realtableDataI
				
				var realtableDataIImax = newtabledataI.filter((item, index) => index > 15)
				var realtableDataII = getdataII().tableDataII
				realtableDataII.forEach((item, index) => {
					if (realtableDataIImax&&realtableDataIImax[index]) {
						this.IHead.forEach(gtem => {
							item[gtem] = realtableDataIImax[index][gtem]
						})
					}
				})
				this.tableDataII_II = realtableDataII
				//附表二
				var newtabledataIII = dataarr.cwbbqykjzd_2
				var realtableDataIII_Imax = newtabledataIII.filter((item, index) => index < 34)
				var realtableDataIII_I = getdataIII().tableDataI
				realtableDataIII_I.forEach((item, index) => {
					if (realtableDataIII_Imax&&realtableDataIII_Imax[index]) {
						this.IIHead.forEach(gtem => {
							item[gtem] = realtableDataIII_Imax[index][gtem]
						})
					}
				})
				this.tableDataIII_I = realtableDataIII_I
				
				var realtableDataIII_IImax = newtabledataIII.filter((item, index) => index > 33)
				var realtableDataIII_II = getdataIII().tableDataII
				realtableDataIII_II.forEach((item, index) => {
					if (realtableDataIII_IImax&&realtableDataIII_IImax[index]) {
						this.IIHead.forEach(gtem => {
							item[gtem] = realtableDataIII_IImax[index][gtem]
						})
					}
				})
				this.tableDataIII_II = realtableDataIII_II
				//附表三
				var newtabledataIII = dataarr.cwbbqykjzd_3
				var realtableDataIII = getdataVI().tableDataI
				realtableDataIII.forEach((item, index) => {
					if (newtabledataIII&&newtabledataIII[index]) {
						this.IIIHead.forEach(gtem => {
							item[gtem] = newtabledataIII[index][gtem]
						})
					}
				})
				this.tableDataVI = realtableDataIII
			},

			forsave() {
				const newarr = [...this.filternums(this.tableDataVI, this.IIIHead), 
					 ...this.filternums(this.tableDataII_II,this.IHead), 
					 ...this.filternums(this.tableDataIII_I,this.IIHead),
					 ...this.filternums(this.tableDataIII_II, this.IIHead), 
					 ...this.filternums(this.tableDataI_I, this.ZeroHead), 
					 ...this.filternums(this.tableDataI_II, this.ZeroHead), 
					 ...this.filternums(this.tableDataII_I, this.IHead)]
				let params = {
					"cells": newarr,
					checkFlag:true,
					"companyNo": this.params.companyNo,
					"id": this.params.id,
					"sbbm": this.params.sbbm,
					"head": this.headobj
				}
				writesave(params).then(res => {
					if (res.data.code == 1) {
						this.Changed = 0
						this.querycell()
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			//主表关系
			//附表一关系
			inputblur(e) {
				this.Changed++
				if ((parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this
						.choosecolum
					]['cellOldVal']).toFixed(2)) && this[this.choosetable][this.chooseindex][this.choosecolum][
						'cellCode'
					] == e.cellCode) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = "1"
				}
				if (e.cellCode == "cwbbqykjzd_0_1_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_1_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_2_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_2_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_3_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_3_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_5_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_5_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_6_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_6_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_7_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_7_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_8_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_8_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_8_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_8_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_10_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_10_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_11_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_11_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_21_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_21_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_24_1") {
					this.cwbbqykjzd_0_31_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_24_2") {
					this.cwbbqykjzd_0_31_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_31_1") {
					this.changetableval("cwbbqykjzd_0_67_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_31_2") {
					this.changetableval("cwbbqykjzd_0_67_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_32_1") {
					this.changetableval("cwbbqykjzd_0_38_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_32_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_34_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_32_2") {
					this.changetableval("cwbbqykjzd_0_38_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_32_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_34_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_34_1") {
					this.changetableval("cwbbqykjzd_0_38_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_32_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_34_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_34_2") {
					this.changetableval("cwbbqykjzd_0_38_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_32_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_34_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_38_1") {
					this.changetableval("cwbbqykjzd_0_67_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_38_2") {
					this.changetableval("cwbbqykjzd_0_67_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_39_1") {
					this.changetableval("cwbbqykjzd_0_41_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_39_1", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_40_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_39_2") {
					this.changetableval("cwbbqykjzd_0_38_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_39_2", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_40_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_40_1") {
					this.changetableval("cwbbqykjzd_0_41_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_39_1", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_40_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_40_2") {
					this.changetableval("cwbbqykjzd_0_41_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_39_2", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_40_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_41_1") {
					this.changetableval("cwbbqykjzd_0_43_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_41_1", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_42_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_41_2") {
					this.changetableval("cwbbqykjzd_0_43_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_41_2", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_42_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_42_1") {
					this.changetableval("cwbbqykjzd_0_43_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_41_1", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_42_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_42_2") {
					this.changetableval("cwbbqykjzd_0_43_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_41_2", 'tableDataI_I') -
						this.gettableval("cwbbqykjzd_0_42_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_43_1") {
					this.changetableval("cwbbqykjzd_0_50_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_43_2") {
					this.changetableval("cwbbqykjzd_0_50_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_44_1") {
					this.changetableval("cwbbqykjzd_0_50_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_44_2") {
					this.changetableval("cwbbqykjzd_0_50_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_45_1") {
					this.changetableval("cwbbqykjzd_0_50_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_45_2") {
					this.changetableval("cwbbqykjzd_0_50_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_46_1") {
					this.changetableval("cwbbqykjzd_0_50_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_46_2") {
					this.changetableval("cwbbqykjzd_0_50_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_43_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_44_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_45_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_46_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_50_1") {
					this.changetableval("cwbbqykjzd_0_67_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_50_2") {
					this.changetableval("cwbbqykjzd_0_67_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_51_1") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_51_2") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_52_1") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_52_2") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_53_1") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_53_2") {
					this.changetableval("cwbbqykjzd_0_60_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_51_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_52_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_53_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_60_1") {
					this.changetableval("cwbbqykjzd_0_67_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_60_2") {
					this.changetableval("cwbbqykjzd_0_67_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_61_1") {
					this.changetableval("cwbbqykjzd_0_67_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_1", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_1", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_61_2") {
					this.changetableval("cwbbqykjzd_0_67_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_31_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_38_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_50_2", 'tableDataI_I') +
						this.gettableval("cwbbqykjzd_0_60_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_61_2", 'tableDataI_I'))
				}
				if (e.cellCode == "cwbbqykjzd_0_68_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_68_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_69_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_69_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_70_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_70_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_71_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_71_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_72_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_72_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_73_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_73_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_74_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_74_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_75_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_75_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_80_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_80_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_81_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_81_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_82_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_82_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_83_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_83_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_86_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_86_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_90_1") {
					this.cwbbqykjzd_0_100_1()
				}
				if (e.cellCode == "cwbbqykjzd_0_90_2") {
					this.cwbbqykjzd_0_100_2()
				}
				if (e.cellCode == "cwbbqykjzd_0_100_1") {
					this.changetableval("cwbbqykjzd_0_114_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_100_2") {
					this.changetableval("cwbbqykjzd_0_114_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_101_1") {
					this.changetableval("cwbbqykjzd_0_110_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_101_2") {
					this.changetableval("cwbbqykjzd_0_110_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_102_1") {
					this.changetableval("cwbbqykjzd_0_110_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_102_2") {
					this.changetableval("cwbbqykjzd_0_110_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_103_1") {
					this.changetableval("cwbbqykjzd_0_110_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_103_2") {
					this.changetableval("cwbbqykjzd_0_110_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_106_1") {
					this.changetableval("cwbbqykjzd_0_110_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_106_2") {
					this.changetableval("cwbbqykjzd_0_110_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_2", 'tableDataI_II')+
						this.gettableval("cwbbqykjzd_0_106_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_108_1") {
					this.changetableval("cwbbqykjzd_0_110_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_106_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_108_2") {
					this.changetableval("cwbbqykjzd_0_110_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_101_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_102_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_103_2", 'tableDataI_II')+
						this.gettableval("cwbbqykjzd_0_106_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_108_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_110_1") {
					this.changetableval("cwbbqykjzd_0_114_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_110_2") {
					this.changetableval("cwbbqykjzd_0_114_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_111_1") {
					this.changetableval("cwbbqykjzd_0_114_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_111_2") {
					this.changetableval("cwbbqykjzd_0_114_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_110_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_111_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_114_1") {
					this.changetableval("cwbbqykjzd_0_135_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_114_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_122_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_114_2") {
					this.changetableval("cwbbqykjzd_0_135_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_122_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_115_1") {
					this.changetableval("cwbbqykjzd_0_117_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_115_1", 'tableDataI_II') -
						this.gettableval("cwbbqykjzd_0_116_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_115_2") {
					this.changetableval("cwbbqykjzd_0_117_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') -
						this.gettableval("cwbbqykjzd_0_116_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_116_1") {
					this.changetableval("cwbbqykjzd_0_117_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_115_1", 'tableDataI_II') -
						this.gettableval("cwbbqykjzd_0_116_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_116_2") {
					this.changetableval("cwbbqykjzd_0_117_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') -
						this.gettableval("cwbbqykjzd_0_116_2", 'tableDataI_II'))
				}	
				if (e.cellCode == "cwbbqykjzd_0_117_1") {
					this.changetableval("cwbbqykjzd_0_122_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_117_1") {
					this.changetableval("cwbbqykjzd_0_122_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_2", 'tableDataI_II'))
				}	
				if (e.cellCode == "cwbbqykjzd_0_118_1") {
					this.changetableval("cwbbqykjzd_0_122_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_118_2") {
					this.changetableval("cwbbqykjzd_0_122_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_2", 'tableDataI_II'))
				}	
				if (e.cellCode == "cwbbqykjzd_0_119_1") {
					this.changetableval("cwbbqykjzd_0_122_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_119_2") {
					this.changetableval("cwbbqykjzd_0_122_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_2", 'tableDataI_II'))
				}	
				if (e.cellCode == "cwbbqykjzd_0_121_1") {
					this.changetableval("cwbbqykjzd_0_122_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_121_2") {
					this.changetableval("cwbbqykjzd_0_122_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_117_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_118_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_119_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_121_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_122_1") {
					this.changetableval("cwbbqykjzd_0_135_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_114_1", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_122_1", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_0_122_2") {
					this.changetableval("cwbbqykjzd_0_135_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_100_2", 'tableDataI_II') +
						this.gettableval("cwbbqykjzd_0_122_2", 'tableDataI_II'))
				}
				if (e.cellCode == "cwbbqykjzd_1_1_1") {
					this.changetableval("cwbbqykjzd_1_10_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_1_2") {
					this.changetableval("cwbbqykjzd_1_10_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_4_1") {
					this.changetableval("cwbbqykjzd_1_10_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_4_2") {
					this.changetableval("cwbbqykjzd_1_10_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_5_1") {
					this.changetableval("cwbbqykjzd_1_10_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_5_2") {
					this.changetableval("cwbbqykjzd_1_10_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_1_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_4_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_5_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_10_1") {
					this.changetableval("cwbbqykjzd_1_18_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_10_2") {
					this.changetableval("cwbbqykjzd_1_18_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_11_1") {
					this.changetableval("cwbbqykjzd_1_18_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_11_2") {
					this.changetableval("cwbbqykjzd_1_18_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_14_1") {
					this.changetableval("cwbbqykjzd_1_18_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_14_2") {
					this.changetableval("cwbbqykjzd_1_18_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_15_1") {
					this.changetableval("cwbbqykjzd_1_18_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_15_2") {
					this.changetableval("cwbbqykjzd_1_18_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_16_1") {
					this.changetableval("cwbbqykjzd_1_18_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_1", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_16_2") {
					this.changetableval("cwbbqykjzd_1_18_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_10_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_11_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_14_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_15_2", 'tableDataII_I')- this.gettableval("cwbbqykjzd_1_16_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_18_1") {
					this.changetableval("cwbbqykjzd_1_27_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_18_2") {
					this.changetableval("cwbbqykjzd_1_27_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_19_1") {
					this.changetableval("cwbbqykjzd_1_27_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_19_2") {
					this.changetableval("cwbbqykjzd_1_27_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_23_1") {
					this.changetableval("cwbbqykjzd_1_27_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_23_2") {
					this.changetableval("cwbbqykjzd_1_27_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_25_1") {
					this.changetableval("cwbbqykjzd_1_27_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_25_2") {
					this.changetableval("cwbbqykjzd_1_27_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_26_1") {
					this.changetableval("cwbbqykjzd_1_27_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_1", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_1", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_26_2") {
					this.changetableval("cwbbqykjzd_1_27_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_18_2", 'tableDataII_I') +
						this.gettableval("cwbbqykjzd_1_19_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_23_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_25_2", 'tableDataII_I')+ this.gettableval("cwbbqykjzd_1_26_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_27_1") {
					this.changetableval("cwbbqykjzd_1_30_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_27_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_28_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_27_2") {
					this.changetableval("cwbbqykjzd_1_30_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_27_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_28_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_28_1") {
					this.changetableval("cwbbqykjzd_1_30_1", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_27_1", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_28_1", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_1_28_2") {
					this.changetableval("cwbbqykjzd_1_30_2", 'tableDataII_I', this.gettableval("cwbbqykjzd_1_27_2", 'tableDataII_I') -
						this.gettableval("cwbbqykjzd_1_28_2", 'tableDataII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_1_1") {
					this.changetableval("cwbbqykjzd_2_9_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_1_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_3_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_8_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_3_1") {
					this.changetableval("cwbbqykjzd_2_9_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_1_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_3_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_8_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_8_1") {
					this.changetableval("cwbbqykjzd_2_9_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_1_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_3_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_8_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_9_1") {
					this.changetableval("cwbbqykjzd_2_21_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_9_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_20_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_10_1") {
					this.changetableval("cwbbqykjzd_2_20_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_10_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_12_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_13_1", 'tableDataIII_I')+ 
						this.gettableval("cwbbqykjzd_2_18_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_12_1") {
					this.changetableval("cwbbqykjzd_2_20_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_10_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_12_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_13_1", 'tableDataIII_I')+ 
						this.gettableval("cwbbqykjzd_2_18_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_13_1") {
					this.changetableval("cwbbqykjzd_2_20_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_10_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_12_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_13_1", 'tableDataIII_I')+ 
						this.gettableval("cwbbqykjzd_2_18_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_18_1") {
					this.changetableval("cwbbqykjzd_2_20_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_10_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_12_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_13_1", 'tableDataIII_I')+ 
						this.gettableval("cwbbqykjzd_2_18_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_20_1") {
					this.changetableval("cwbbqykjzd_2_21_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_9_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_20_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_21_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_21_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_37_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_54_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_55_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_22_1") {
					this.changetableval("cwbbqykjzd_2_56_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_22_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_23_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_25_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_28_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_23_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_22_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_23_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_25_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_28_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_25_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_22_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_23_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_25_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_28_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_28_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_22_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_23_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_25_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_28_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_29_1") {
					this.changetableval("cwbbqykjzd_2_37_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_29_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_36_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_30_1") {
					this.changetableval("cwbbqykjzd_2_36_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_30_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_31_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_35_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_31_1") {
					this.changetableval("cwbbqykjzd_2_36_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_30_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_31_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_35_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_35_1") {
					this.changetableval("cwbbqykjzd_2_36_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_30_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_31_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_35_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_36_1") {
					this.changetableval("cwbbqykjzd_2_37_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_29_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_36_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_37_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_21_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_37_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_54_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_55_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_38_1") {
					this.changetableval("cwbbqykjzd_2_44_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_38_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_40_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_43_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_40_1") {
					this.changetableval("cwbbqykjzd_2_44_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_38_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_40_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_43_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_43_1") {
					this.changetableval("cwbbqykjzd_2_44_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_38_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_40_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_43_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_44_1") {
					this.changetableval("cwbbqykjzd_2_54_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_44_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_53_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_45_1") {
					this.changetableval("cwbbqykjzd_2_53_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_45_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_46_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_52_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_46_1") {
					this.changetableval("cwbbqykjzd_2_53_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_45_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_46_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_52_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_52_1") {
					this.changetableval("cwbbqykjzd_2_53_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_45_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_46_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_52_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_53_1") {
					this.changetableval("cwbbqykjzd_2_54_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_44_1", 'tableDataIII_I') -
						this.gettableval("cwbbqykjzd_2_53_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_54_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_21_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_37_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_54_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_55_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_55_1") {
					this.changetableval("cwbbqykjzd_2_29_1", 'tableDataIII_I', this.gettableval("cwbbqykjzd_2_21_1", 'tableDataIII_I') +
						this.gettableval("cwbbqykjzd_2_37_1", 'tableDataIII_I')+ this.gettableval("cwbbqykjzd_2_54_1", 'tableDataIII_I')+
						this.gettableval("cwbbqykjzd_2_55_1", 'tableDataIII_I'))
				}
				if (e.cellCode == "cwbbqykjzd_2_57_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_58_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_59_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_60_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_61_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_64_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_65_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_66_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_67_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_68_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_69_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_70_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_71_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_72_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_73_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_74_1") {
					this.cwbbqykjzd_2_75_1()
				}
				if (e.cellCode == "cwbbqykjzd_2_79_1") {
					this.changetableval("cwbbqykjzd_2_83_1", 'tableDataIII_II', this.gettableval("cwbbqykjzd_2_79_1", 'tableDataIII_II') -
						this.gettableval("cwbbqykjzd_2_80_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_81_1", 'tableDataIII_II') - 
						this.gettableval("cwbbqykjzd_2_82_1", 'tableDataIII_II'))
				}
				if (e.cellCode == "cwbbqykjzd_2_80_1") {
					this.changetableval("cwbbqykjzd_2_83_1", 'tableDataIII_II', this.gettableval("cwbbqykjzd_2_79_1", 'tableDataIII_II') -
						this.gettableval("cwbbqykjzd_2_80_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_81_1", 'tableDataIII_II') - 
						this.gettableval("cwbbqykjzd_2_82_1", 'tableDataIII_II'))
				}
				if (e.cellCode == "cwbbqykjzd_2_81_1") {
					this.changetableval("cwbbqykjzd_2_83_1", 'tableDataIII_II', this.gettableval("cwbbqykjzd_2_79_1", 'tableDataIII_II') -
						this.gettableval("cwbbqykjzd_2_80_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_81_1", 'tableDataIII_II') - 
						this.gettableval("cwbbqykjzd_2_82_1", 'tableDataIII_II'))
				}
				if (e.cellCode == "cwbbqykjzd_2_82_1") {
					this.changetableval("cwbbqykjzd_2_83_1", 'tableDataIII_II', this.gettableval("cwbbqykjzd_2_79_1", 'tableDataIII_II') -
						this.gettableval("cwbbqykjzd_2_80_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_81_1", 'tableDataIII_II') - 
						this.gettableval("cwbbqykjzd_2_82_1", 'tableDataIII_II'))
				}
			},
			
			cwbbqykjzd_0_31_1(){
				this.changetableval("cwbbqykjzd_0_31_1", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_1_1", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_2_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_3_1", 'tableDataI_I') + 
					this.gettableval("cwbbqykjzd_0_4_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_5_1", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_6_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_7_1", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_8_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_9_1", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_10_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_11_1", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_21_1", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_24_1", 'tableDataI_I'))
			},
			cwbbqykjzd_0_31_2(){
				this.changetableval("cwbbqykjzd_0_31_2", 'tableDataI_I', this.gettableval("cwbbqykjzd_0_1_2", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_2_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_3_2", 'tableDataI_I') + 
					this.gettableval("cwbbqykjzd_0_4_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_5_2", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_6_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_7_2", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_8_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_9_2", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_10_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_11_2", 'tableDataI_I') +
					this.gettableval("cwbbqykjzd_0_21_2", 'tableDataI_I')+ this.gettableval("cwbbqykjzd_0_24_2", 'tableDataI_I'))
			},
			cwbbqykjzd_0_100_1(){
				this.changetableval("cwbbqykjzd_0_100_1", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_68_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_69_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_70_1", 'tableDataI_II') + 
					this.gettableval("cwbbqykjzd_0_71_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_72_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_73_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_74_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_75_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_80_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_81_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_82_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_83_1", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_86_1", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_90_1", 'tableDataI_II'))
			},
			cwbbqykjzd_0_100_2(){
				this.changetableval("cwbbqykjzd_0_100_2", 'tableDataI_II', this.gettableval("cwbbqykjzd_0_68_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_69_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_70_2", 'tableDataI_II') + 
					this.gettableval("cwbbqykjzd_0_71_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_72_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_73_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_74_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_75_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_80_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_81_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_82_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_83_2", 'tableDataI_II')+ this.gettableval("cwbbqykjzd_0_86_2", 'tableDataI_II') +
					this.gettableval("cwbbqykjzd_0_90_2", 'tableDataI_II'))
			},
			cwbbqykjzd_2_75_1(){
				this.changetableval("cwbbqykjzd_2_75_1", 'tableDataIII_II', this.gettableval("cwbbqykjzd_2_57_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_58_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_59_1", 'tableDataIII_II') + 
					this.gettableval("cwbbqykjzd_2_60_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_61_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_64_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_65_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_66_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_67_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_68_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_69_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_70_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_71_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_72_1", 'tableDataIII_II')+ this.gettableval("cwbbqykjzd_2_73_1", 'tableDataIII_II') +
					this.gettableval("cwbbqykjzd_2_74_1", 'tableDataIII_II'))
			},
			gettableval(changecode, table, old) {
				var head = ''
				if (table == 'tableDataI_I' || table == 'tableDataI_II') {
					head = 'ZeroHead'
				}
				if (table == 'tableDataII_I' || table == 'tableDataII_II') {
					head = 'IHead'
				}
				if (table == 'tableDataIII_I' || table == 'tableDataIII_II') {
					head = 'IIHead'
				}
				if (table == 'tableDataVI_I') {
					head = 'IIIHead'
				}
				var a
				if (this[table] && this[head]) {
					for (let i = 0; i < this[table].length; i++) {
						for (let j = 0; j < this[head].length; j++) {
							if (this[table][i][this[head][j]] && this[table][i][this[head][j]].cellCode && this[table][i][
									this[
										head][j]
								].cellVal && this[table][i][this[head][j]].cellCode == changecode) {
								if (old) {
									if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
										a = 0
									} else {
										a = parseFloat(this[table][i][this[head][j]].goujgxValue)
									}
								} else {
									if (this[table][i][this[head][j]].cellVal == '- -') {
										a = 0
									} else {
										a = parseFloat(this[table][i][this[head][j]].cellVal || 0)
									}
								}
								break
							}
						}
					}
				}
				a = a || 0
				return a
			},
			changetableval(changecode, table, newval, checkq) {
				var newval = newval || 0
				newval = this.toFixed(newval,2)
				var head = ''
				if (table == 'tableDataI_I' || table == 'tableDataI_II') {
					head = 'ZeroHead'
				}
				if (table == 'tableDataII_I' || table == 'tableDataII_II') {
					head = 'IHead'
				}
				if (table == 'tableDataIII_I' || table == 'tableDataIII_II') {
					head = 'IIHead'
				}
				if (table == 'tableDataVI_I') {
					head = 'IIIHead'
				}
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (this[table][i][this[head][j]] && this[table][i][this[head][j]].cellCode && typeof this[table][
								i
							][this[head][j]].cellVal != 'undefined' && typeof this[table][i][this[head][j]].cellVal !=
							undefined && this[table][i][this[head][j]].cellCode == changecode) {
							if (this[table][i][this[head][j]].cellVal != newval) {
								if (this.suosq.substring(4, 6) < 5 && checkq) {
									this[table][i][this[head][j]].cellVal = ""
								} else {
									this[table][i][this[head][j]].cellVal = newval + ""
								}
								this.inputblur({
									cellCode: changecode,
									cellVal: newval
								})
								break
							}
						}
					}
				}
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
